
/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

    // Analytics event tracking
    $('.ncd.downloadimg').click(function() {
        ga('send', 'event', 'New Guest Offer', 'Download', 'Specials Image');
    });

    $('.ncd.button').click(function() {
        ga('send', 'event', 'New Guest Offer', 'Download', 'Specials Button');
    });

// Navigation

	// Mobile Subnav
	$('.subnav-toggle').click(function() {
		$('.widget_nav_menu').slideToggle('300', 'swing');
		$(this).toggleClass('active');
	});

    $('.phone_toggle').click(function() {
        $(this).find('ul').slideToggle('300', 'swing');
        $(this).toggleClass('active');
    });

    $('.hour_toggle').click(function() {
        var $hours = $(this).parent().find('.hours_drop');
        $($hours).slideToggle('300', 'swing');
        $(this).toggleClass('active');
        $(this).parentsUntil('btm_location').siblings().children().find('.hours_drop').slideUp();
        $(this).parentsUntil('btm_location').siblings().children().find('.hour_toggle').removeClass('active');
        return false;
    });

    $(".hours_drop").on("click", function (event) {
        event.stopPropagation();
    });

    $(".subnav-toggle").on("click", function (event) {
        event.stopPropagation();
    });

    $(".phone_toggle").on("click", function (event) {
        event.stopPropagation();
    });

    $(document).on("click", function () {
        $('.hours_drop').slideUp();
        $('.widget_nav_menu').slideUp();
        $('.phone_toggle').find('ul').slideUp();
        $('.hour_toggle').removeClass('active');
        $('.subnav-toggle').removeClass('active');
        $('.phone_toggle').removeClass('active');
    });
    
    $('.accordion').on('down.zf.accordion', function (event) {
        console.log('Accordion done');
        $('html, body').animate({
            scrollTop: $('.accordion-item.is-active').offset().top
        }, 1000);
    });

});

(function($) {
    var $window = $(window),
        $html = $('body');

    function resize() {
        if ($window.width() < 480) {
            return $html.addClass('mobile'),
                $('.parent-li').on('click', function() {
                    $(this).children('ul').slideToggle();
                    $('body').toggleClass('body-fix');
                });

        }

        $html.removeClass('mobile');
    }

    $window
        .resize(resize)
        .trigger('resize');
})(jQuery);